(function (ws) {
    'use strict';
    ws.views.ManualrmaSerialNumbers = ws.views.modal.extend({

        /**
         * Events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .rma-select-all': 'selectAll',
            'click [type=submit]': 'applySelected',
            'keyup #searchSerialNo': 'searchSerialNo'
        }),

        /**
         * Initialize override.
         */
        initialize: function (options) {
            this.error = false;
            this.options = options;
            this.collection = new ws.collections.rmaSerialNumbersCollection({
                model: ws.models.rmaSerialNumbersModel
            });
            this.$serialNumberList = this.$('.rma-box');
            this.$apiError = $('.api-error-message');
            ws.views.modal.prototype.initialize.call(this);

            this.listenTo(this.collection, 'reset', this.render);

            this.collection.fetch({
                data: {
                    orderCode: this.options.orderCode,
                    entryNumber: this.options.entryNumber
                },
                reset: true
            }).done(function () {
                // check if serial number exists in selected serial numbers and pre-select it if it does
                this.collection.each(function (model) {
                    if (this.options.selectedSerialNumbers.indexOf(model.get('serialNumber')) !== -1) {
                        model.set('selected', true);
                    }
                }.bind(this));
            }.bind(this)).fail(function() {
                this.$apiError.show();
            }.bind(this));

            this.$('#searchSerialNo').val('');

            this.$serialNumberError = this.$('.serial-number-error');
        },

        /**
         * Clean up events
         */
        cleanUpEvents: function() {
            this.undelegateEvents();
            this.$(this.el).empty();
        },

        /**
         * Fetch and render contents.
         */
        render: function () {
            this.collection.each(function (item) {
                var view = new ws.views.rmaSerialNumber({model: item});
                this.$serialNumberList.append(view.render().el);
            }.bind(this));

            if (this.collection.length > 0) {
                ws.views.modal.prototype.render.call(this);
            }
        },

        /**
         * Toggle select all products.
         * @param {Object} ev - Event object
         */
        selectAll: function (ev) {
            this.collection.each(function (item) {
                // check if serial number exists in a filtered list
                var hasInput = this.$serialNumberList.find('[name=serialNumber]').filter(function (index, el) {
                    return el.value === item.get('serialNumber');
                });

                if (hasInput.length) {
                    item.set({
                        selected: !!ev.currentTarget.checked
                    });
                }
            }.bind(this));
        },

        /**
         * Handle Submit button click.
         */
        applySelected: function () {
            this.error = false;

            this.checkEmptySerialsNumbers();

            if (this.error) {
                return false;
            }

            var $input = $('#selectedSerialNumbers-' + this.options.entryNumber);
            var selected = this.collection.selected().map(function (model) {
                return model.get('serialNumber');
            }).join(', ');

            $input.val(selected);
            $input.next('span').html(selected);
            this.closeModal();
        },

        /**
         * Check if the user doesn't select any serial number
         */
        checkEmptySerialsNumbers: function () {
            var checkboxes = this.$('.custom-checkbox:checked');
            this.$serialNumberError.hide();

            if (checkboxes.length === 0) {
                this.$serialNumberError.show();
                this.error = true;
            }
        },

        /**
         * Close modal override. Since we're fetching collection for each modal instance, we need to destroy previous
         * collection to avoid serial number duplication.
         */
        closeModal: function () {
            this.$serialNumberList.html('');
            this.$('.rma-select-all').prop('checked', false);
            this.cleanUpEvents();
            ws.views.modal.prototype.closeModal.call(this);
        },

        /**
         * Search Serial No
         * @param {Object} ev
         */
        searchSerialNo: function (ev) {
            var filtered = this.collection.search(ev.currentTarget.value);
            this.$serialNumberList.html('');

            _.each(filtered, function (item) {
                var view = new ws.views.rmaSerialNumber({model: item});
                this.$serialNumberList.append(view.render().el);
            }.bind(this));
        }
    });

    ws.views.rmaSerialNumber = Backbone.View.extend({
        tagName: 'li',
        className: 'rma-box-item',

        events: {
            'change [name=serialNumber]': 'toggleSelected'
        },

        /**
         * Initialize view.
         */
        initialize: function () {
            this.listenTo(this.model, 'change', this.render);
        },

        /**
         * Render list items.
         */
        render: function () {
            var template = _.template($('#serial-number-item-template').html());
            this.$el.html(template(this.model.toJSON()));
            this.$('[name=serialNumber]').prop('checked', this.model.get('selected'));
            return this;
        },

        /**
         * Change model selected state based on checkbox selection.
         * @param {Object} ev - Event object
         */
        toggleSelected: function (ev) {
            this.model.set({
                selected: !!ev.currentTarget.checked
            });
        }
    });
})(westcon);
